module.exports = __webpack_public_path__ + "docs/img/apple-touch-icon.e66ae083.png";